import React, {Fragment} from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

export const WeatherBroadcastNavigation = props => {
  const [map, setMap] = React.useState(
    props.data.maps[Object.keys(props.data.maps)[0]].id
  );

  const handleChange = (event, newMap) => {
    if (map !== newMap && newMap !== null) {
      setMap(newMap);
      props.setMap(newMap);
    }
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center'
      }}>
      <ToggleButtonGroup
        style={{backgroundColor: 'white', display: 'flex', alignSelf: 'center'}}
        color='primary'
        value={map}
        exclusive
        onChange={handleChange}>
        {Object.keys(props.data.maps).map((key, i) => {
          const fallbackKey = (props.data.maps[key] || {}).id || `${key}_${i}`;
          if (props.data.title === 'Lokalzeit am Samstag') {
            if (key === 'prognose') {
              return <Fragment key={fallbackKey} />;
            }
          }

          if (key === 'hdtext_heute_klein') {
            return <Fragment key={fallbackKey} />;
          }

          return (
            <ToggleButton
              key={props.data.maps[key].id}
              value={props.data.maps[key].id}
              style={{textTransform: 'none'}}>
              {props.data.maps[key].displayTitle}
            </ToggleButton>
          );
        })}
      </ToggleButtonGroup>
    </div>
  );
};
